module.exports = __webpack_public_path__ + "static/media/iconRadioButton.06bbde30.svg";